<div class="modal-body">
  <div class="content">
    <div class="content__top">
      <h4 translate>company.dids.add-testing-did.popup.title</h4>
      <button type="button" class="close" aria-label="Close" (click)="close()">
        <i class="icon-small-close"></i>
      </button>
    </div>
    <div class="content__main" *ngIf="!loading.get && !loading.submit">
      <form [formGroup]="form">
        <div class="form-group">
          <label for="add-testing-did-phone" translate>company.dids.add-testing-did.popup.form.phone.label</label>
          <div class="vox-input-group vox-input-group_dense"
          [ngClass]="{'vox-input-group_invalid': isFieldInvalid('phone')}">
              <vox-phone-text-field [state]="countryCode" [dense]="true" formControlName="phone"
              (onStateChanged)="onChangeState($event)"></vox-phone-text-field>
              <i class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i>
              <span *ngIf="form.controls.phone.errors && form.controls.phone.errors.required"
              class="vox-input-group__error-message" translate>company.dids.add-testing-did.popup.form.required</span>
              <span *ngIf="form.controls.phone.errors && !form.controls.phone.errors.required"
              class="vox-input-group__error-message" translate>company.dids.add-testing-did.popup.form.phone.invalid</span>
          </div>
        </div>
        <div class="form-group">
          <label for="add-testing-did-class" translate>company.dids.add-testing-did.popup.form.class.label</label>
          <div ngbDropdown class="vox-dropdown-input">
              <button class="dropdown__btn" id="add-testing-did-class" ngbDropdownToggle>
                <span>{{form.value.class | didClass}}</span>
              </button>
              <div ngbDropdownMenu aria-labelledby="add-testing-did-class">
                <button ngbDropdownItem class="dropdown__item" *ngFor="let class of availableClasses"
                (click)="selectDidClass(class)"><span>{{class | didClass}}</span>
                </button>
              </div>
          </div>
        </div>
        <div class="form-group">
          <label for="add-testing-did-type" translate>company.dids.add-testing-did.popup.form.type.label</label>
          <div ngbDropdown class="vox-dropdown-input">
              <button class="dropdown__btn" id="add-testing-did-type" ngbDropdownToggle>
                <span>{{form.value.type | didType}}</span>
              </button>
              <div ngbDropdownMenu aria-labelledby="add-testing-did-type">
                <button ngbDropdownItem class="dropdown__item" *ngFor="let type of availableTypes"
                (click)="selectDidType(type)"><span>{{type | didType}}</span>
                </button>
              </div>
          </div>
        </div>
        <div class="form-group">
          <label for="replace-did-provider" translate>company.dids.replace-with-existing-did.popup.form.provider.label</label>
          <gdp-select-provider formControlName="provider" [providers]="availableProviders"></gdp-select-provider>
        </div>
        <div class="form-group">
          <label for="add-testing-did-provider-reference" translate>company.dids.add-testing-did.popup.form.provider-reference.label</label>
          <div class="vox-input-group vox-input-group_dense">
              <input class="vox-text-field" type="text"
              id="add-testing-did-provider-reference" formControlName="providerReference"
              [placeholder]="'company.dids.add-testing-did.popup.form.provider-reference.placeholder' | translate">
          </div>
        </div>
        <div class="submit-container">
          <button class="vox-btn vox-btn-primary" type="submit"
          [disabled]="form.invalid" (click)="onSubmit()">
              <span translate>company.dids.add-testing-did.popup.form.submit</span>
          </button>
        </div>
      </form>
    </div>
    <div class="content_main" *ngIf="loading.get || loading.submit">
      <div class="form-group" *ngFor="let i of [1,2,3,4,5]">
        <ngx-skeleton-loader [theme]="{'height': '24px', 'width': '120px', 'margin-left': '0px', 'margin-bottom': '0px'}"></ngx-skeleton-loader>
        <div class="vox-input-group">
          <ngx-skeleton-loader [theme]="{'height': '40px', 'margin-left': '0px', 'margin-right': '0px', 'margin-bottom': '-7px'}"></ngx-skeleton-loader>
        </div>
      </div>
      <div class="submit-container">
        <ngx-skeleton-loader [theme]="{'height': '56px', 'width': '68px', 'margin-left': '0px', 'margin-right': '0px', 'margin-bottom': '0px', 'float': 'right'}"></ngx-skeleton-loader>
      </div>
    </div>
  </div>
</div>